/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".disabledRow[_ngcontent-%COMP%]{color:silver}.disabledRow.dx-state-hover[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{color:silver!important}"];
export { styles as styles };
